<template>
  <div class="introduction">
    <div class="col-12 headerContent">
      <h3 v-html="program.howTheProgramWorksHeader"></h3>
      <div class="content-holder">
        <span v-html="program.howTheProgramWorksText" class="content"></span>
      </div>
      <a :href="program.programSummaryButtonLink" target="_blank" class="button" v-if="hasProgramLink" 
      v-html="`${program.programSummaryButtonLabel} <span class='visually-hidden'>&nbsp;link opens in new window</span>`"></a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Summary",
  props: {
    program: Object,
  },
  computed: {
    hasProgramLink() {
      return this.program.programSummaryButtonLink && this.program.programSummaryButtonLabel;
    },
  },
};
</script>
<style lang="scss">
.row {
  .introTitle {
    padding: 40px 40px;
    .subHeaderText {
      font-size: 24px;
      line-height: 150%;
      color: var(--primaryText);

      p {
        font-size: 24px;
        line-height: 150%;
      }
    }

    .headline {
      font-size: 48px;
      line-height: 120%;
      font-weight: 400;
      color: var(--secondaryText);

      p {
        color: inherit;
        font-size: inherit;
      }
    }

    
  }
}

.introduction {
  .button {
    @include round-btn();
    padding: 16px;
    line-height: 10.67px;
    display: inline-block;
  }
}

.introduction p,
.introduction h2 {
  font-weight: 400;
}

.headerContent {
  font-family: var(--micrositeTypeStyle);

  h3 {
    margin: 0 0 20px 0;
  }
  .content-holder {
    margin-bottom: 30px;
  }
  .content {
    font-size: 15px;
    color: var(--primaryText);    
  }
}

.introduction .headerContent {
  background-color: var(--backgroundAccent);
  padding: 40px;
}

@include media-breakpoint-down(md) {
  .introduction .introTitle,
  .headerContent {
    padding: 30px !important;
  }
}
  @include media-breakpoint-down(sm) {
        .introduction .introTitle {
        padding: 24px 24px 32px !important;
    }
    
      .headline{
        font-size:24px !important;
        font-weight: 700 !important;
        line-height:120% !important;
      }
    }
</style>
